export const formatMissingText = (text?: string | number): string => {
  return text ? `${text}` : '-';
};
